import { z } from 'zod';

export const DataplaneDLQMessage = z.object({
  message: z.string().describe('JSON representation of the message that was send to the DLQ on the dataplane'),
});

export type DataplaneDLQMessageType = z.infer<typeof DataplaneDLQMessage>;
